// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import { useEffect, useState } from 'react'

const useSortedTableData = (tableData, tableSort, sortTableData) => {
  const [sortedTableData, setSortedTableData] = useState(() => sortTableData(tableData, tableSort))

  useEffect(() => {
    setSortedTableData(() => sortTableData(tableData, tableSort))
  }, [tableData, tableSort])

  return sortedTableData
}

export default useSortedTableData
